import { useNavigate } from 'react-router-dom'; 
import Icon from "../../images/Icons/gg_debug.png"
const Card = ({ title, description, iconClass, hue1, hue2, id,img }) => {
  const navigate = useNavigate();
  const handleSlideClick = (eventId) => {
    navigate(`/event/${eventId}`); // Navigate to EventDetails with event ID
  };
  return (
    <article className="card__article" style={{ "--hue-1": hue1, "--hue-2": hue2 }}>
      <div className="card__scale-1"></div>
      <div className="card__scale-2"></div>

      <div className="card__shape-1">
        <div className="card__shape-2"></div>
        <div className="card__shape-3">
          <img src={img} className="icon   " alt="" />
        </div>
      </div>

      <div className="card__data">
        <h2 className="card__title">{title}</h2>
        <p className="card__description">{description}</p>
        <a className="event-btn" onClick={() => handleSlideClick(id)}>Know More</a>
      </div>
    </article>
  );
};

export default Card;